import {Link} from "react-router-dom";
import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import Routing from "../../../../Routing.ts";
import Icon from "../../../../components/selfcare/Icon.tsx";
import IconArrow from "../../../../components/icons/IconArrow.tsx";
import {ScrollToAnchorPoint} from "../../../../util/ScrollToAnchor.tsx";
import {WhatConnectionType} from "../../../../components/help/CommonQuestions.tsx";

export default function UnstableArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className={'article'}>
                    <h2>
                        Vælg dit produkt for at finde hjælp
                    </h2>
                    <div className={'button-container'}>
                        <a href={'#fiber'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har fibernet
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#coax-dsl'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har internet via kabel-tv-stikket
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#coax-dsl'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har internet via telefonstikket
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#mbb'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har 5G-internet
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#not-sure'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg ved ikke, hvilket produkt jeg har
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'fiber'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <h2>Jeg har fibernet</h2>
                    <ul className="list list--number">
                        <li>
                            <p>
                                Er dit internet ustabilt på bestemte enheder, kan du tjekke wifi-signalstyrken på de pågældende enheder i <Link to={Routing.Selfcare.Internet} target={'_blank'}>Mit Hiper</Link> på <strong>Internet</strong>-fanen under <strong>Wifi-indstillinger og -oversigt</strong>.
                            </p>
                        </li>
                        <li>
                            <p>Tjek om internettet også er ustabilt med et netværkskabel.</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>Sæt et netværkskabel fra routeren til f.eks. en computer og tjek, om internettet også er ustabilt på den.</p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Genstart din router.</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>Sluk den og vent 30 sekunder, før du tænder den igen.</p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Nulstil din router.</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>Hold en spids genstand inde i &ldquo;reset&rdquo; hullet bag på routeren i 15-20 sekunder, mens routeren er tændt.</p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Genstart alle dine enheder, hvor internettet er ustabilt på.</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>F.eks. tv, tablet, computer og telefoner.</p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Tjek om din router er placeret optimalt &ndash; tre huskeregler:</p>
                            <ul className="list list--number">
                                <li>
                                    <p>Centralt i boligen eller i det rum, hvor du opholder dig mest.</p>
                                </li>
                                <li>
                                    <p>Så højt som muligt.</p>
                                </li>
                                <li>
                                    <p>Væk fra elementer, der kan påvirke wifi-signalet (Mikrobølgeovn, køleskab, babyalarmer, spejle mm.).</p>
                                    <p>
                                        Læs mere om <Link
                                        to="/hjaelp/internet-og-wifi/placering-af-router"
                                    >hvordan du placerer din router et godt sted her</Link>.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Tjek om du bruger de to frekvenser 2,4 og 5 GHz optimalt</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>
                                        Læs hvordan i{' '}
                                        <Link to="/hjaelp/internet-og-wifi/forskel-paa-signal-frekvenser">
                                            denne artikel om signalfrekvenser
                                        </Link>.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>
                                Bruger du din egen router?
                                Så anbefaler vi, at du også tester ovenstående på din Hiper-router.
                            </p>
                        </li>
                        <li>
                            <p>
                                Hvis ovenstående ikke hjælper, kan du fejlmelde dit internet under <strong>Internet</strong>-fanen i <Link to={Routing.Selfcare.Internet} target={'_blank'}>Mit Hiper</Link>.
                            </p>
                        </li>
                    </ul>
                </div>

                <ScrollToAnchorPoint id={'coax-dsl'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <h2>Jeg har internet via kabel-tv-stikket / telefonstik</h2>
                    <ul className="list list--number">
                        <li>
                            <p>Tjek om internettet også er ustabilt med et netværkskabel.</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>Sæt et netværkskabel fra routeren til f.eks. en computer og tjek, om internettet også er ustabilt på den.</p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Genstart din router.</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>Sluk den og vent 30 sekunder, før du tænder den igen.</p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Nulstil din router.</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>Hold en spids genstand inde i &ldquo;reset&rdquo; hullet bag på routeren i 15-20 sekunder, mens routeren er tændt.</p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Genstart alle dine enheder, hvor internettet er ustabilt på.</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>F.eks. tv, tablet, computer og telefoner.</p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Tjek om din router er placeret optimalt &ndash; tre huskeregler:</p>
                            <ul className="list list--number">
                                <li>
                                    <p>Centralt i boligen eller i det rum, hvor du opholder dig mest.</p>
                                </li>
                                <li>
                                    <p>Så højt som muligt.</p>
                                </li>
                                <li>
                                    <p>Væk fra elementer, der kan påvirke wifi-signalet (Mikrobølgeovn, køleskab, babyalarmer, spejle mm.).</p>
                                    <p>
                                        Læs mere om <Link
                                        to="/hjaelp/internet-og-wifi/placering-af-router"
                                    >hvordan du placerer din router et godt sted her</Link>.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Tjek om du bruger de to frekvenser 2,4 og 5 GHz optimalt</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>
                                        Læs hvordan i{' '}
                                        <Link to="/hjaelp/internet-og-wifi/forskel-paa-signal-frekvenser">
                                            denne artikel om signalfrekvenser
                                        </Link>.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>
                                Bruger du din egen router?
                                Så anbefaler vi, at du også tester ovenstående på din Hiper-router.
                            </p>
                        </li>
                        <li>
                            <p>
                                Hvis ovenstående ikke hjælper, kan du fejlmelde dit internet under <strong>Internet</strong>-fanen i <Link
                                to={Routing.Selfcare.Internet}
                                target={'_blank'}
                            >Mit Hiper</Link>.
                            </p>
                        </li>
                    </ul>
                </div>

                <ScrollToAnchorPoint id={'mbb'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <h2>Jeg har 5G-internet</h2>
                    <ul className="list list--number">
                        <li>
                            <p>Tjek om din router er placeret optimalt:</p>
                            <ul className="list list--number">
                                <li>
                                    <p>Placér routeren i en vindueskarm, så den har nemmest ved at opfange 5G-signalet.</p>
                                </li>
                                <li>
                                    <p>Stil den så højt som muligt.</p>
                                </li>
                                <li>
                                    <p>Stil den væk fra elementer, der kan påvirke dit wifi (bl.a. spejl, mikroovn, køleskab, babyalarm).</p>
                                    <p>
                                        Læs mere om <Link
                                        to="/hjaelp/internet-og-wifi/placering-af-router"
                                    >hvordan du placerer din router et godt sted her</Link>.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Tjek om internettet også er ustabilt med et netværkskabel.</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>Sæt et netværkskabel fra routeren til f.eks. en computer og tjek, om internettet også er ustabilt på den.</p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Genstart din router.</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>Sluk den og vent 30 sekunder, før du tænder den igen.</p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Nulstil din router.</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>Hold en spids genstand inde i &ldquo;reset&rdquo; hullet bag på routeren i 15-20 sekunder, mens routeren er tændt.</p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>Genstart alle dine enheder, hvor internettet er ustabilt på.</p>
                            <ul className="list list--bullet">
                                <li>
                                    <p>F.eks. tv, tablet, computer og telefoner.</p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>
                                Hvis ovenstående ikke hjælper, kan du fejlmelde dit internet under <strong>Internet</strong>-fanen i <Link
                                to={Routing.Selfcare.Internet}
                                target={'_blank'}
                            >Mit Hiper</Link>.
                            </p>
                        </li>
                    </ul>
                </div>

                <ScrollToAnchorPoint id={'not-sure'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h3>{WhatConnectionType.question}</h3>
                        {WhatConnectionType.answer}
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        category: "internet-og-wifi",
                        article: "forventninger-til-wifi",
                        name: "Hvad kan jeg forvente af mit wifi?"
                    },
                    {
                        category: "internet-og-wifi",
                        article: "placering-af-router",
                        name: "Tips til placering af router"
                    },
                    {
                        category: "internet-og-wifi",
                        article: "skift-navn-og-kode-paa-wifi",
                        name: "Skift navn og kode på wifi"
                    }
                ]}
            />
        </>
    )
}
